module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [(_vm.site_view == 1) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0 1.08em"
    }
  }, [(_vm.set_show_header) ? _c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card-body"
  }, [(_vm.menu_tab_inner_view['addNewCategory']) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('h4', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "margin-left": "1em"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setToView('')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]), _vm._v("  ")]), _vm._v("New Category")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12"
  }, [_c('div', {
    staticClass: "form-card"
  }, [_c('form', {
    staticClass: "sp-form sp-forms-one"
  }, [(_vm.categories.length != 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Pick a Category Name")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(ct) {
    return _c('option', {
      key: ct.category_id,
      domProps: {
        "value": ct
      }
    }, [_vm._v(_vm._s(ct.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Category under " + _vm._s(_vm.main_category.category_name))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_category),
      expression: "category.new_category"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "width": "245px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.category.new_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(ct) {
    return _c('option', {
      key: ct.sub_category_id,
      domProps: {
        "value": ct.sub_category_id
      }
    }, [_vm._v(_vm._s(ct.sub_category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.categories.length != 0) ? _c('label', [_c('b', [_vm._v("OR")]), _vm._v(" provide a category"), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_listed_category),
      expression: "category.new_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Category Name"
    },
    domProps: {
      "value": (_vm.category.new_listed_category)
    },
    on: {
      "change": _vm.resetCategoriesSelections,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.new_listed_category = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#084c8b"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addCategory
    }
  }, [_vm._v("Add Category")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', [(_vm.site_view == 1) ? _c('hr') : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Categories")])]), _vm._v(" "), _c('div', _vm._l((_vm.sellpoint.business_categories), function(set_category, index) {
    return _c('div', {
      staticClass: "card",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('div', {
      staticClass: "col-xs-12 card-row-xx mp0",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em",
        "background-color": "#ffffff",
        "border": "#eee 1px solid"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.prepSetCategoryView(set_category)
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-3",
      staticStyle: {
        "padding-top": "0.82em"
      }
    }, [(set_category.business_category_image) ? _c('img', {
      staticStyle: {
        "height": "55px",
        "width": "100%"
      },
      attrs: {
        "src": set_category.business_category_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "height": "55px",
        "width": "85px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', {
      staticClass: "card-details-x",
      staticStyle: {
        "border-radius": "0 0 14px 14px",
        "background": "#ffffff",
        "padding": "1em",
        "padding-top": "1.6em"
      }
    }, [_c('div', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "14px",
        "text-align": "left",
        "background": "#ffffff"
      }
    }, [_c('span', [_c('span', [_vm._v(_vm._s(set_category.business_category_name))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("No of Items:Products: " + _vm._s(set_category.business_category_total_products))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])])])
  }))])])]) : (_vm.menu_tab_inner_view['editProduct']) ? _c('div', [(_vm.product_details.editProduct) ? _c('div', {
    staticClass: "row"
  }, [_c('h4', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "margin-left": "1em"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setToView('viewItem')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]), _vm._v("  ")]), _vm._v("Edit Product")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12"
  }, [_c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("Category:- " + _vm._s(_vm.product.product_category_name) + " ")]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v(" Change Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": _vm.category_type_1
    },
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('div', {
    staticClass: "form-group col-md-12"
  }, [(_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "form-control category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v(" *Product Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control txtarea",
    staticStyle: {
      "height": "8em"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 col-md-4 x-btn",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [(_vm.action_loading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v(" Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 col-md-4 x-btn",
    staticStyle: {
      "margin-right": "5px",
      "background-color": "#000000",
      "border-color": "#000000",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setToView('viewItem');
        _vm.setComponent('reset-edit', '');
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', [(_vm.site_view == 1) ? _c('hr') : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Product Details")]), _vm._v(" "), _c('h5', [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "t-info"
  }, [_vm._v(_vm._s(_vm.product.product_name))])]), _vm._v(" "), _c('h5', [_vm._m(3), _vm._v(" "), (_vm.product.product_items[0].product_item_price_f) ? _c('span', {
    staticClass: "t-info"
  }, [_vm._v("₦‎" + _vm._s(_vm.product.product_items[0].product_item_price_f))]) : _vm._e()]), _vm._v(" "), _c('h5', [_vm._m(4), _vm._v(" "), _c('span', {
    staticClass: "t-info"
  }, [_vm._v(_vm._s(_vm.product.product_category_name))])])])])]) : _vm._e()]) : (_vm.menu_tab_inner_view['addProduct']) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [(Object.keys(_vm.category).length > 0) ? _c('div', [_c('h4', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "margin-left": "1em"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('viewCategory')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]), _vm._v("  ")]), _vm._v("New Product")])]) : _c('div', [_c('h4', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "margin-left": "1em"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setToView('')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]), _vm._v("  ")]), _vm._v("New Product")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [(Object.keys(_vm.category).length > 0) ? _c('div', [_c('h4', [_vm._v("Add to "), _c('i', [_c('b', [_vm._v(_vm._s(_vm.category.business_category_name))])])])]) : _c('div', [(Object.keys(_vm.sellpoint.business_categories).length > 0) ? _c('div', [_c('h4', [_vm._v("Select Category")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat, index) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v("\r\n                    " + _vm._s(cat.business_category_name) + "\r\n                  ")])
  })], 2)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Upload Photo ")]), _vm._v(" "), (Object.keys(_vm.file_info).length == 0) ? _c('div', {
    staticClass: "card card-dummy-photo"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80%",
      "max-height": "400px"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), (Object.keys(_vm.file_info).length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "1.4em"
    }
  }, [_c('a', {
    staticClass: "card-link btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "left",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.file_info = {};
        _vm.resetImageUpload();
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "0.8em"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "60%"
    }
  }, [_c('div', {
    staticClass: "sp-form-descr"
  }, [_c('span', [_vm._v("Maximum Upload Size " + _vm._s(_vm.max_upload))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(1 to 5 pictures)")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "40%"
    }
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "padding": "1em 1.2em",
      "font-size": "14px",
      "line-height": "0.8",
      "border-color": "#c8232c",
      "background-color": "#c8232c",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Select Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewProduct($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15em"
    }
  }, [(_vm.site_view == 1) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card container-fluid"
  }, [_c('h6', [_vm._v("Add " + _vm._s(_vm.set_str_attr.product.name) + " Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name of the Item"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "How Much?",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "change": function($event) {
        _vm.numStrip()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Details")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Add Details or Description"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.set_product_is_addon == 0) ? _c('div', {
    staticClass: "container-fluid-x",
    staticStyle: {
      "margin": "0 1em"
    }
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-left": "0em"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('setOrderOptions');
        _vm.jumpToView('setOrderOptions')
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "cb-right-xx",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "setOrderOptions"
    }
  }, [_c('div', {
    staticClass: "cardbox"
  }, [_c('div', {
    staticClass: "cb-card"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setOrderOptionView('orderOptions');
      }
    }
  }, [_vm._m(6), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.set_tab_inner_view['orderOptions']) ? _c('div', {
    staticClass: "card cd-card-inner",
    attrs: {
      "id": "orderOptions"
    }
  }, [_c('div', {
    staticClass: "container-x"
  }, [_c('h3', [_vm._v("eg:")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, _vm._l((_vm.product_set_items), function(d) {
    return _c('p', [_vm._v(_vm._s(d.name) + " - " + _vm._s(d.amount) + " "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm",
      on: {
        "click": function($event) {
          _vm.removeOrderProductItemsOptions(d)
        }
      }
    }, [_vm._v("x")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Option")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.name),
      expression: "product_item.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product_item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Total Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.amount),
      expression: "product_item.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_item.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.amount = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setAddOrderProductItemsOptions(_vm.product_item)
      }
    }
  }, [_vm._v("Add")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cardbox"
  }, [_c('div', {
    staticClass: "cb-card"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setOrderOptionView('orderExtra2');
      }
    }
  }, [_vm._m(9), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.set_tab_inner_view['orderExtra2']) ? _c('div', {
    staticClass: "card cd-card-inner",
    attrs: {
      "id": "orderExtra2"
    }
  }, [_c('div', {
    staticClass: "card"
  }, _vm._l((_vm.product_set_details), function(d) {
    return _c('p', [_vm._v(_vm._s(d.set_name) + " "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm",
      on: {
        "click": function($event) {
          _vm.removeProductOrderOptions(d)
        }
      }
    }, [_vm._v("x")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name of Item")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_detail.set_name),
      expression: "set_detail.set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.set_detail.set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.set_detail.set_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_detail.set_cost),
      expression: "set_detail.set_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.set_detail.set_cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.set_detail.set_cost = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setAddProductOrderOptions(_vm.set_detail)
      }
    }
  }, [_vm._v("Add")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cardbox"
  }, [_c('div', {
    staticClass: "cb-card"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setOrderOptionView('orderExtra3');
      }
    }
  }, [_vm._m(11), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.set_tab_inner_view['orderExtra3']) ? _c('div', {
    staticClass: "card cd-card-inner",
    attrs: {
      "id": "orderExtra3"
    }
  }, [_c('div', {
    staticClass: "card"
  }, _vm._l((_vm.product_set_details), function(d) {
    return _c('p', [_vm._v(_vm._s(d.set_name) + " "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm",
      on: {
        "click": function($event) {
          _vm.removeProductOrderOptions(d)
        }
      }
    }, [_vm._v("x")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_detail.set_name),
      expression: "set_detail.set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.set_detail.set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.set_detail.set_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setAddProductOrderOptions(_vm.set_detail)
      }
    }
  }, [_vm._v("Add")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#1a73da"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message)), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addProduct()
      }
    }
  }, [_vm._v("Add Item Order")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), ((_vm.site_view == 1)) ? _c('div', {
    staticStyle: {
      "padding-top": "5em"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "margin-top": "8em",
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "jumpToSetOrderOptions"
    }
  })]) : _vm._e()])])])])]) : (_vm.menu_tab_inner_view['setOrderOptions']) ? _c('div', [_c('div', [_c('h4', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('viewItem')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]), _vm._v("  ")]), _vm._v("Set Order Options")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-xs-12",
    staticStyle: {
      "margin-bottom": "4em"
    }
  }, [_c('div', {}, [_vm._m(13), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._l((_vm.product_set_items), function(d, dex) {
    return _c('p', [_vm._v(_vm._s(++dex) + " " + _vm._s(d.name) + " - " + _vm._s(d.amount) + " "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "4px 5px"
      },
      on: {
        "click": function($event) {
          _vm.removeOrderProductItemsOptions(d)
        }
      }
    }, [_vm._v("Remove")])])
  }), _vm._v(" "), (_vm.product_set_items.length > 0) ? _c('div', {}, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.setAddProductItems()
      }
    }
  }, [_vm._v("Done, Add these options")]), _vm._v(" "), _c('hr')]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h5', [_vm._v("Add a new option")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Option")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.name),
      expression: "product_item.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product_item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.amount),
      expression: "product_item.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product_item.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.amount = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.setAddOrderProductItemsOptions(_vm.product_item)
      }
    }
  }, [_vm._v("Enter")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('h4', [_vm._v("Current Options")]), _vm._v(" "), _vm._l((_vm.product.product_items), function(item, product_item_index) {
    return _c('div', {}, [_c('div', {
      staticClass: "card col-xs-12 mp0",
      staticStyle: {
        "margin-bottom": "1em",
        "padding": "1em 0.2em",
        "border": "1px solid #eee",
        "border-radius": "3px"
      }
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('p', [(item.product_item_service_tag == 'nill' && product_item_index == 0) ? _c('span', [_c('b', [_vm._v("Main")])]) : _c('span', [_vm._v(_vm._s(item.product_item_service_tag))])]), _vm._v(" "), (_vm.checkOrderItems(item)) ? _c('p', [_c('span', {
      attrs: {
        "id": 'prdQty' + product_item_index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', _vm.product_index, _vm.product_item, product_item_index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(_vm.product_item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', _vm.product_index, _vm.product_item, product_item_index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5 mp0"
    }, [_c('p', [_vm._v("₦‎" + _vm._s(item.product_item_price_f))])])])])
  })], 2)])]) : (_vm.menu_tab_inner_view['setOrderExtras']) ? _c('div', [_c('div', [_c('h4', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setToView('viewItem')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]), _vm._v("  ")]), _vm._v("Set Order Options")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-xs-12",
    staticStyle: {
      "margin-bottom": "4em"
    }
  }, [_c('p', [_vm._v("What is in your order that can be removed, can be ordered without... eg. onions, vegetable ...")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._l((_vm.product_set_details), function(d) {
    return _c('p', [_vm._v(_vm._s(d.set_name) + " \r\n              "), _c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.removeProductOrderOptions(d)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "13px",
        "color": "#ff0000"
      }
    }, [_vm._v("x Remove")])])])
  }), _vm._v(" "), (_vm.product_set_details.length > 0) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-02-sm",
    on: {
      "click": function($event) {
        _vm.addProductDetails(_vm.product)
      }
    }
  }, [(_vm.action_loading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v(" Done, add these options")])]) : _vm._e(), _vm._v(" "), _c('hr')], 2), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h5', [_vm._v("Add a new item")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name of Item")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_detail.set_name),
      expression: "set_detail.set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.set_detail.set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.set_detail.set_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_detail.set_cost),
      expression: "set_detail.set_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.set_detail.set_cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.set_detail.set_cost = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.setAddProductOrderOptions(_vm.set_detail)
      }
    }
  }, [_vm._v("Enter")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('h4', [_vm._v("Current List")]), _vm._v(" "), (Object.keys(_vm.product.product_information).length > 0) ? _c('div', {
    staticClass: "card"
  }, _vm._l((_vm.product.product_information), function(info, infodex) {
    return _c('div', [_c('p', [_vm._v(_vm._s(++infodex) + " " + _vm._s(info.product_info_set_name))])])
  })) : _vm._e()])])]) : (_vm.menu_tab_inner_view['viewItem']) ? _c('div', [_c('div', [_c('h1', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setToView('')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]), _vm._v("  ")]), _vm._v("Item: " + _vm._s(_vm.product.product_name))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cardbox"
  }, [(_vm.site_view == 2) ? _c('div', {
    staticClass: "cb-card",
    staticStyle: {
      "border-bottom": "#eee solid 0px"
    }
  }, [_c('h3', [_vm._v("Order Pictures")])]) : _vm._e(), _vm._v(" "), (_vm.site_view == 1) ? _c('div', {
    staticClass: "cb-card"
  }, [_c('div', {
    staticClass: "cb-left"
  }, [_c('h3', [_vm._v("Order Pictures")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "orderImagesView"
    }
  }, [_c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin-bottom": "1em",
      "z-index": "5",
      "background": "#ffffff",
      "border-radius": "14px"
    }
  }, [((_vm.product_display_image.product_image && (_vm.product_display_image.product_image != ''))) ? _c('img', {
    staticClass: "img-responsive-x",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.product_display_image.product_image
    }
  }) : _c('img', {
    staticClass: "img-responsive-x",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })]), _vm._v(" "), (_vm.product.product_images && (Object.keys(_vm.product.product_images).length > 0)) ? _c('div', {
    staticClass: "col-xs-3"
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('orderImages', 'orderImagesView')
      }
    }
  }, [_vm._v("+" + _vm._s(Object.keys(_vm.product.product_images).length) + " more photos")])]) : _vm._e()])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('orderImages', 'orderImagesView')
      }
    }
  }, [_vm._m(14)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card cd-card-inner cd-card-inner-img",
    attrs: {
      "id": "orderImages"
    }
  }, [_c('div', {
    staticClass: "col-md-2 col-xs-12 mp0"
  }, [_c('div', {
    staticClass: "img-row",
    staticStyle: {
      "margin-bottom": "5px",
      "width": "100%"
    }
  }, [_vm._l((_vm.product.product_images), function(pt, tex) {
    return _c('li', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.product_display_image = pt
        }
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": _vm.img_product_url + pt.product_image,
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _c('hr')], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 col-xs-12 mp0"
  }, [_c('div', {
    staticClass: "col-xs-12 mp0"
  }, [(_vm.set_inner_view == 'p-image' + _vm.product_display_image.product_image_id) ? _c('div', {
    staticStyle: {
      "padding": "0.4em 1em"
    }
  }, [_c('hr'), _vm._v(" "), _c('div', [_vm._m(15), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.deleteProductImage(_vm.pt.product_image_id)
      }
    }
  }, [(_vm.action_loading) ? _c('i', {
    staticClass: "fas fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v(" Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.set_inner_view = ''
      }
    }
  }, [_vm._v("No")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-colxx col-xs-10 mp0",
    staticStyle: {
      "margin-bottom": "1em",
      "z-index": "5",
      "background": "#ffffff",
      "border-radius": "14px"
    }
  }, [(_vm.product_display_image && (Object.keys(_vm.product_display_image).length > 0)) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.product_display_image.product_image
    }
  }) : _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "8px",
      "margin-left": "0.7em"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_inner_view = 'p-image' + _vm.product_display_image.product_image_id;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-trash",
    staticStyle: {
      "font-size": "22px",
      "color": "#ff0000"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn x-btn",
    staticStyle: {
      "padding": "5px 6px",
      "font-size": "14px",
      "border": "#eee solid 1px"
    },
    attrs: {
      "type": "button"
    }
  }, [(_vm.action_loading) ? _c('i', {
    staticClass: "fas fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fas fa-plus",
    staticStyle: {
      "font-size": "22px",
      "color": "#ff0000"
    }
  }), _c('br'), _vm._m(16)]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12",
    staticStyle: {
      "margin-bottom": "4em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cardbox"
  }, [_c('div', {
    staticClass: "cb-card"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('orderDetails');
        _vm.jumpToView('orderDetails')
      }
    }
  }, [_c('div', {
    staticClass: "cb-left"
  }, [_c('h3', [_vm._v("Order Details")]), _vm._v(" "), _c('p', [_vm._v("Name: "), _c('b', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(", Price, Description")])]), _vm._v(" "), _vm._m(17)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card cd-card-inner",
    attrs: {
      "id": "orderDetails"
    }
  }, [_c('div', [_c('h5', [_vm._m(18), _vm._v(" "), _c('span', {
    staticClass: "t-info"
  }, [_vm._v(_vm._s(_vm.product.product_name))])]), _vm._v(" "), _c('h5', [_vm._m(19), _vm._v(" "), (_vm.product.product_items[0].product_item_price_f) ? _c('span', {
    staticClass: "t-info"
  }, [_vm._v("₦‎" + _vm._s(_vm.product.product_items[0].product_item_price_f))]) : _vm._e()]), _vm._v(" "), _c('h5', [_vm._m(20), _vm._v(" "), _c('span', {
    staticClass: "t-info"
  }, [_vm._v(_vm._s(_vm.product.product_category_name))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._m(21), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs sp-button-02",
    staticStyle: {
      "padding": "6px 8px"
    },
    on: {
      "click": function($event) {
        _vm.setToView('editProduct');
        _vm.setProductComponent('editProduct', '')
      }
    }
  }, [_vm._v("Edit Product Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cardbox"
  }, [_c('div', {
    staticClass: "cb-card"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('orderOptions');
        _vm.jumpToView('orderOptions')
      }
    }
  }, [_vm._m(22), _vm._v(" "), _vm._m(23)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card cd-card-inner",
    attrs: {
      "id": "orderOptions"
    }
  }, [(_vm.product.product_items && (Object.keys(_vm.product.product_items).length > 1)) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-bottom": "5em"
    }
  }, _vm._l((_vm.product.product_items), function(item, product_item_index) {
    return _c('div', {}, [_c('div', {
      staticClass: "card col-xs-12 mp0",
      staticStyle: {
        "margin-bottom": "1em",
        "padding": "1em 0.2em",
        "border": "1px solid #eee",
        "border-radius": "3px"
      }
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('p', [(item.product_item_service_tag == 'nill' && product_item_index == 0) ? _c('span', [_c('b', [_vm._v("Main")])]) : _c('span', [_vm._v(_vm._s(item.product_item_service_tag))])]), _vm._v(" "), (_vm.checkOrderItems(item)) ? _c('p', [_c('span', {
      attrs: {
        "id": 'prdQty' + product_item_index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', _vm.product_index, _vm.product_item, product_item_index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(_vm.product_item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', _vm.product_index, _vm.product_item, product_item_index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 mp0"
    }, [_c('p', [_vm._v("₦‎" + _vm._s(item.product_item_price_f))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.product_item = item;
          _vm.set_inner_view = 'PRITM-ED' + product_item_index
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "13px",
        "color": "#ff0000"
      }
    }, [_vm._v("Change")])]), _vm._v(" "), _vm._m(24, true), _vm._v(" "), _c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.product_item = item;
          _vm.set_inner_view = 'PRITM-DL' + product_item_index
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "13px",
        "color": "#ff0000"
      }
    }, [_vm._v("Remove")])])]), _vm._v(" "), (_vm.set_inner_view == 'PRITM-ED' + product_item_index) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Option")]), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item.product_item_service_tag),
        expression: "product_item.product_item_service_tag"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_item.product_item_service_tag)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item.product_item_service_tag = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Total Cost")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item.product_item_price),
        expression: "product_item.product_item_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_item.product_item_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item.product_item_price = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn sp-button-02-lt",
      on: {
        "click": function($event) {
          _vm.editProductItem()
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      on: {
        "click": function($event) {
          _vm.set_inner_view = ''
        }
      }
    }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), (_vm.set_inner_view == 'PRITM-DL' + product_item_index) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', [_vm._m(25, true), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn sp-button-02-lt",
      on: {
        "click": function($event) {
          _vm.removeProductItem()
        }
      }
    }, [_vm._v("Yes, Remove")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      on: {
        "click": function($event) {
          _vm.set_inner_view = ''
        }
      }
    }, [_vm._v("Cancel")])])])]) : _vm._e()])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('button', {
    staticClass: "btn btn-xs sp-button-02",
    staticStyle: {
      "padding": "6px 8px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setOrderOptions');
      }
    }
  }, [_vm._v("Set Order Options")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cardbox"
  }, [_c('div', {
    staticClass: "cb-card"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('orderExtra2');
        _vm.jumpToView('orderExtra2')
      }
    }
  }, [_vm._m(26), _vm._v(" "), _vm._m(27)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card cd-card-inner",
    attrs: {
      "id": "orderExtra2"
    }
  }, [(Object.keys(_vm.product.product_information).length > 0) ? _c('div', {
    staticClass: "card"
  }, [_vm._l((_vm.product.product_information), function(info, infodex) {
    return _c('div', [_c('div', {
      staticClass: "card col-xs-12 mp0",
      staticStyle: {
        "margin-bottom": "1em",
        "padding": "1em 0.2em",
        "border": "1px solid #eee",
        "border-radius": "3px"
      }
    }, [_c('div', {
      staticClass: "col-xs-9"
    }, [_c('p', [_vm._v(_vm._s(info.product_info_set_name) + " \r\n                          ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.set_inner_view = 'PRINF-DL' + infodex
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "13px",
        "color": "#ff0000"
      }
    }, [_vm._v("Remove")])])]), _vm._v(" "), (_vm.set_inner_view == 'PRINF-DL' + infodex) ? _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', [_vm._m(28, true), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm",
      on: {
        "click": function($event) {
          _vm.removeProductInformation(info)
        }
      }
    }, [(_vm.action_loading) ? _c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    }) : _vm._e(), _vm._v(" Yes, Remove")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-02-sm sp-button-02-cancel",
      on: {
        "click": function($event) {
          _vm.set_inner_view = ''
        }
      }
    }, [_vm._v("Cancel")])])])]) : _vm._e()])])
  }), _vm._v(" "), _c('hr')], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('button', {
    staticClass: "btn btn-xs sp-button-02",
    staticStyle: {
      "padding": "6px 8px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('setOrderExtras');
      }
    }
  }, [_vm._v("Set Order Extras")])])])])])])])]) : (_vm.menu_tab_inner_view['addCategory']) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('h4', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "margin-left": "1em"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setToView('viewItem')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]), _vm._v("  ")]), _vm._v("New Product")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12"
  }, [(Object.keys(_vm.category).length > 0) ? _c('div', [_c('h4', [_vm._v("Add to "), _c('i', [_c('b', [_vm._v(_vm._s(_vm.category.business_category_name))])])])]) : _c('div', [_c('h4', [_vm._v("Select Category")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat, index) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v("\r\n                    " + _vm._s(cat.business_category_name) + "\r\n                  ")])
  })], 2)])])]), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "sp-form"
  }, [_c('h6', [_vm._v("Add New "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Product Photo ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Maximum Upload Size " + _vm._s(_vm.max_upload))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Display "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewProduct($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _vm._m(29)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', [_vm._v("Name")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name of Product / Service"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Price")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "change": function($event) {
        _vm.numStrip()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Details")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name of Product / Service"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#1a73da"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message)), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("ADD "), _c('span', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', [(_vm.site_view == 1) ? _c('hr') : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Product Details")]), _vm._v(" "), _c('h5', [_vm._m(30), _vm._v(" "), _c('span', {
    staticClass: "t-info"
  }, [_vm._v(_vm._s(_vm.product.product_name))])]), _vm._v(" "), _vm._m(31), _vm._v(" "), _c('h5', [_vm._m(32), _vm._v(" "), _c('span', {
    staticClass: "t-info"
  }, [_vm._v(_vm._s(_vm.product.product_category_name))])])])])])]) : (_vm.menu_tab_inner_view['viewCategory']) ? _c('div', [_c('div', [_c('h3', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setToView('')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  })]), _vm._v("  ")]), _vm._v(" "), _c('b', [_vm._v("Category:")]), _vm._v(" " + _vm._s(_vm.category.business_category_name) + "\r\n        ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticClass: "row-x"
  }, [_c('div', {
    staticClass: "cardbox"
  }, [_c('div', [_c('div', [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%",
      "display": "none"
    }
  }, [_c('h3', [_c('b', [_vm._v("Category:")]), _vm._v(" " + _vm._s(_vm.category.business_category_name))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-xs-2-x",
    staticStyle: {
      "margin-bottom": "1em",
      "z-index": "5",
      "background": "#ffffff",
      "border-radius": "14px"
    }
  }, [(_vm.category.business_category_image) ? _c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "max-height": "320px"
    },
    attrs: {
      "src": _vm.category.business_category_image
    }
  }) : _c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "max-height": "320px"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-sm sp-app-default-background-color",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.product.product_category = _vm.category.business_category_id;
        _vm.setMenuTabInnerView('addProduct')
      }
    }
  }, [_vm._v("Add items to this Category")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12",
    staticStyle: {
      "margin-bottom": "4em"
    }
  }, [_c('div', {
    staticClass: "row-x"
  }, [(_vm.site_view == 2) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "3em",
      "margin-bottom": "2em"
    }
  }, [_c('h3', [_vm._v("Manage Category")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-line"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('x-cat-00')
      }
    }
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Edit/Update Category Details")]), _vm._v(" "), _vm._m(33), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "x-cat-00"
    }
  }, [_vm._v("\r\n                  edit cat\r\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-line"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('x-cat-01')
      }
    }
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Delete Category")]), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "x-cat-01"
    }
  }, [_vm._v("\r\n                  del cat\r\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-line"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('x-cat-02')
      }
    }
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Change Category Picture")]), _vm._v(" "), _vm._m(35), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "x-cat-02"
    }
  }, [_vm._v("\r\n                  upload\r\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-line"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.product.product_category = _vm.category.business_category_id;
        _vm.setMenuTabInnerView('addProduct')
      }
    }
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Add Products/Items to Category")]), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('hr')])])])])]) : _c('div', [(_vm.site_view == 2 && _vm.site_user_type == 2) ? _c('div', {
    staticClass: "card"
  }, [_c('desktop-header-panel')], 1) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view['availableItems']) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "5px",
      "background-color": "#ffffff",
      "padding-bottom": "8em"
    }
  }, [_c('h3', [_vm._v("Available Items")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v("Set Items available on sale today, items set would show on your Store")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "border-bottom": "#000000 solid 0px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_in_view = '';
        _vm.setItemView(0);
        _vm.setToView('')
      }
    }
  }, [_c('h5', [_vm._v("All Items")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_in_view = 'available_items';
      }
    }
  }, [(_vm.set_in_view == 'available_items') ? _c('h5', {
    staticStyle: {
      "color": "#ff0000",
      "border-bottom": "#ff0000 solid 3px"
    }
  }, [_vm._v("Available Items ")]) : _c('h5', [_vm._v("Available Items ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_in_view = 'not_available_items';
      }
    }
  }, [(_vm.set_in_view == 'not_available_items') ? _c('h5', {
    staticStyle: {
      "color": "#ff0000",
      "border-bottom": "#ff0000 solid 3px"
    }
  }, [_vm._v("Items Not Available")]) : _c('h5', [_vm._v("Items Not Available")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [(_vm.set_products_as_available.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "display": "block"
    }
  }, [_c('p', {
    staticStyle: {
      "float": "left",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.set_products_as_available.length) + " item(s) selected")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "float": "right",
      "padding": "5px 18px",
      "background": "#c20312",
      "border-color": "#c20312",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setProductsAvailability()
      }
    }
  }, [_vm._v("Save "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "display": "block"
    }
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr')]) : _vm._e()]), _vm._v(" "), (_vm.data_loading.products || (Object.keys(_vm.products).length == 0)) ? _c('div', {
    staticClass: "col-md-12 mp0"
  }, [(_vm.data_loading.products) ? _c('div', [_vm._m(38)]) : ((Object.keys(_vm.products).length == 0)) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No " + _vm._s(_vm.set_str_attr.product_name) + "s in list")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "padding": "5px 18px",
      "border-radius": "8px"
    },
    on: {
      "click": function($event) {
        _vm.setAddNew(1, 1)
      }
    }
  }, [_vm._v("Add new " + _vm._s(_vm.set_str_attr.product.name))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.set_in_view == 'available_items') ? _c('div', {
    staticClass: "col-md-12 col-xs-12 mp0",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "viewAvailableItems"
    }
  }, [_vm._l((_vm.products), function(set_product, index) {
    return (set_product.product_is_available == 1) ? _c('div', {
      key: index,
      staticClass: "col-md-3 col-xs-6",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('div', {
      staticClass: "card-cd-item",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.product = set_product;
          _vm.getSetProduct(_vm.product);
          _vm.setToView('viewItem');
        }
      }
    }, [_c('div', {
      staticClass: "c-col-img-x col-md-3 col-xs-3 mp0",
      staticStyle: {
        "padding-top": "0.6em",
        "background": "#ffffff",
        "border-radius": "14px"
      }
    }, [(set_product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "border-radius": "4px"
      },
      attrs: {
        "src": set_product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "border-radius": "14px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card col-md-9 col-xs-9",
      staticStyle: {
        "z-index": "1",
        "background": "#ffffff",
        "padding": "5px",
        "padding-left": "1em",
        "padding-top": "0.0em"
      }
    }, [(_vm.site_view == 1) ? _c('div', {
      staticClass: "card-details-x prd-name-1-lines"
    }, [_c('p', {
      staticClass: "prd-name-1-lines",
      staticStyle: {
        "font-size": "13px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(set_product.product_name))])]) : _vm._e(), _vm._v(" "), (_vm.site_view == 2) ? _c('div', {
      staticClass: "card-details-x prd-name-1-lines"
    }, [_c('p', {
      staticClass: "prd-name-1-lines",
      staticStyle: {
        "font-size": "13px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(set_product.product_name))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "-1.5em"
      }
    }, [_c('input', {
      staticClass: "btn sp-button-02-sm",
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddToAvailableProducts(set_product)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "12px",
        "font-weight": "bolder"
      }
    }, [_vm._v(" Not-Available")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : (_vm.set_in_view == 'not_available_items') ? _c('div', {
    staticClass: "col-md-12 col-xs-12 mp0",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "viewNotAvailableItems"
    }
  }, [_vm._l((_vm.products), function(set_product, index) {
    return (set_product.product_is_available == 0) ? _c('div', {
      key: index,
      staticClass: "col-md-3 col-xs-6",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('div', {
      staticClass: "card-cd-item",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.product = set_product;
          _vm.getSetProduct(_vm.product);
          _vm.setToView('viewItem');
        }
      }
    }, [_c('div', {
      staticClass: "c-col-img-x col-md-3 col-xs-3 mp0",
      staticStyle: {
        "padding-top": "0.6em",
        "background": "#ffffff",
        "border-radius": "14px"
      }
    }, [(set_product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "border-radius": "4px"
      },
      attrs: {
        "src": set_product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "border-radius": "14px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card col-md-9 col-xs-9",
      staticStyle: {
        "z-index": "1",
        "background": "#ffffff",
        "padding": "5px",
        "padding-left": "1em",
        "padding-top": "0.0em"
      }
    }, [(_vm.site_view == 1) ? _c('div', {
      staticClass: "card-details-x prd-name-1-lines"
    }, [_c('p', {
      staticClass: "prd-name-1-lines",
      staticStyle: {
        "font-size": "13px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(set_product.product_name))])]) : _vm._e(), _vm._v(" "), (_vm.site_view == 2) ? _c('div', {
      staticClass: "card-details-x prd-name-1-lines"
    }, [_c('p', {
      staticClass: "prd-name-1-lines",
      staticStyle: {
        "font-size": "13px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(set_product.product_name))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "-1.5em"
      }
    }, [_c('input', {
      staticClass: "btn sp-button-02-sm",
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddToAvailableProducts(set_product)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "12px",
        "font-weight": "bolder"
      }
    }, [_vm._v("Available")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2) : _vm._e()]) : _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-av-head"
  }, [_c('h3', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Manage Items")]), _vm._v(" "), _c('div', {
    staticClass: "add-nw-cta-block"
  }, [_c('a', {
    staticClass: "btn sp-button-02 add-nw-cta",
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('addNewOptions')
      }
    }
  }, [_vm._v("Add New "), _c('i', {
    staticClass: "fas fa-angle-down",
    staticStyle: {
      "margin-left": "0.21em"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "add-nw-cta-options",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "addNewOptions"
    }
  }, [_c('ul', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setAddNew(1, 1)
      }
    }
  }, [_vm._m(39)]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setAddNew(1, 2)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-right"
  }), _vm._v(" Regular Item")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setAddNew(2, 3)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-right"
  }), _vm._v(" Category")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "card-av-header"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setItemView(2)
      }
    }
  }, [(_vm.item_view == 2) ? _c('h5', {
    staticStyle: {
      "color": "#ff0000",
      "border-bottom": "#ff0000 solid 3px"
    }
  }, [(_vm.site_view == 1) ? _c('span', [_vm._v("Categories "), _c('br'), _vm._v("or Groups")]) : _c('span', [_vm._v("Categories or Groups")])]) : _c('h5', [(_vm.site_view == 1) ? _c('span', [_vm._v("Categories "), _c('br'), _vm._v("or Groups")]) : _c('span', [_vm._v("Categories or Groups")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "card-av-header"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setItemView(0)
      }
    }
  }, [(_vm.item_view == 0) ? _c('h5', {
    staticStyle: {
      "color": "#ff0000",
      "border-bottom": "#ff0000 solid 3px"
    }
  }, [_vm._v("Main Items")]) : _c('h5', [_vm._v("Main Items")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "card-av-header"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setItemView(1)
      }
    }
  }, [(_vm.item_view == 1) ? _c('h5', {
    staticStyle: {
      "color": "#ff0000",
      "border-bottom": "#ff0000 solid 3px"
    }
  }, [_vm._v("Other Items")]) : _c('h5', [_vm._v("Other Items")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "card-av-header"
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_in_view = 'available_items';
        _vm.setMenuTabInnerView('availableItems')
      }
    }
  }, [_c('h5', [_vm._v("Available Items")])])])])]), _vm._v(" "), (_vm.data_loading.products || (Object.keys(_vm.products).length == 0)) ? _c('div', {
    staticClass: "col-md-12 mp0"
  }, [(_vm.data_loading.products) ? _c('div', [_vm._m(40)]) : ((Object.keys(_vm.products).length == 0)) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No " + _vm._s(_vm.set_str_attr.product.name) + "s in list")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "padding": "5px 18px",
      "border-radius": "8px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('addProduct')
      }
    }
  }, [_vm._v("Add new " + _vm._s(_vm.set_str_attr.product.name))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "8em"
    }
  }, [(_vm.item_view == 2) ? _c('div', [_c('div', {
    staticClass: "col-md-12 col-xs-12 mp0",
    staticStyle: {
      "margin-top": "0.22em"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12",
    attrs: {
      "id": "categoryList"
    }
  }, [_c('div', {
    staticClass: "alt-intro"
  }, [_c('h4', [_vm._v("Categories of Items")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v("Set or Group your " + _vm._s(_vm.set_str_attr.business.name) + " " + _vm._s(_vm.set_str_attr.product.name) + "s into Categories")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mp0"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#777",
      "font-weight": "bold"
    }
  }, [_vm._v("(" + _vm._s(Object.keys(_vm.sellpoint.business_categories).length) + ") Categories")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-sm sp-app-default-background-color",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('addNewCategory')
      }
    }
  }, [_vm._v("Add a new category")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(set_category, index) {
    return _c('div', {
      staticClass: "card",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('div', {
      staticClass: "col-md-4 col-xs-12 card-row-xx mp0",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em",
        "background-color": "#ffffff",
        "border": "#eee 1px solid"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.prepSetCategoryView(set_category)
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-3",
      staticStyle: {
        "padding-top": "0.82em"
      }
    }, [(set_category.business_category_image) ? _c('img', {
      staticStyle: {
        "height": "55px",
        "width": "100%"
      },
      attrs: {
        "src": set_category.business_category_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "height": "55px",
        "width": "85px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', {
      staticClass: "card-details-x",
      staticStyle: {
        "border-radius": "0 0 14px 14px",
        "background": "#ffffff",
        "padding": "1em",
        "padding-top": "1.6em"
      }
    }, [_c('div', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "14px",
        "text-align": "left",
        "background": "#ffffff"
      }
    }, [_c('span', [_c('span', [_vm._v(_vm._s(set_category.business_category_name))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("No of Items:Products: " + _vm._s(set_category.business_category_total_products))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])])])
  })], 2)])]) : (_vm.item_view == 1) ? _c('div', [_c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [(_vm.set_products_as_addons.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "display": "block"
    }
  }, [_c('p', {
    staticStyle: {
      "float": "left",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.set_products_as_addons.length) + " item(s) selected")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "float": "right",
      "padding": "5px 18px",
      "background": "#c20312",
      "border-color": "#c20312",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setProductsAddon()
      }
    }
  }, [_vm._v("Remove "), (_vm.action_loading) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "display": "block"
    }
  }, [_vm._m(41), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "alt-intro"
  }, [_c('h4', [_vm._v("Other Items")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v("Other Regular or Additional " + _vm._s(_vm.set_str_attr.product.name) + "s, eg: Drinks, Accessories")])]), _vm._v(" "), _vm._l((_vm.products), function(set_product, index) {
    return (set_product.product_is_addon == 1) ? _c('div', {
      staticClass: "col-md-2 col-xs-4",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('div', {
      staticClass: "card-cd-item",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.product = set_product;
          _vm.getSetProduct(_vm.product);
          _vm.setToView('viewItem');
        }
      }
    }, [_c('div', {
      staticClass: "c-col-img col-md-12 col-md-12 mp0",
      staticStyle: {
        "z-index": "5",
        "background": "#ffffff",
        "border-radius": "14px"
      }
    }, [(set_product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "border-radius": "14px"
      },
      attrs: {
        "src": set_product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "border-radius": "14px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card col-md-12 col-xs-12 mp0"
    }, [(_vm.site_view == 1) ? _c('div', {
      staticClass: "card-details prd-name-2-lines",
      staticStyle: {
        "z-index": "1",
        "background": "#ffffff",
        "padding": "5px",
        "padding-top": "0.5em"
      }
    }, [_c('p', {
      staticClass: "prd-name-2-lines",
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(set_product.product_name))])]) : _vm._e(), _vm._v(" "), (_vm.site_view == 2) ? _c('div', {
      staticClass: "card-details prd-name-2-lines",
      staticStyle: {
        "z-index": "1",
        "background": "#ffffff",
        "padding": "5px",
        "padding-top": "0.5em"
      }
    }, [_c('p', {
      staticClass: "prd-name-2-lines",
      staticStyle: {
        "font-size": "13px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(set_product.product_name))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "0.5em"
      }
    }, [_c('div', {
      staticStyle: {
        "padding": "5px 8px",
        "text-align": "center",
        "background-color": "#ffe600",
        "color": "#000000",
        "border-radius": "8px"
      }
    }, [_c('input', {
      staticClass: "btn sp-button-02-sm",
      staticStyle: {
        "margin-top": "-2px"
      },
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddToAddonProducts(set_product)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "12px",
        "font-weight": "bolder"
      }
    }, [_vm._v(" Remove")])])])])])]) : _vm._e()
  })], 2)]) : _c('div', [_c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "alt-intro"
  }, [_c('h4', [_vm._v(_vm._s(_vm.set_str_attr.business.name) + " Main " + _vm._s(_vm.set_str_attr.product.name) + "s")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v("All Main " + _vm._s(_vm.set_str_attr.product.name) + "s you sell, "), _c('b', [_vm._v("(" + _vm._s(Object.keys(_vm.products).length) + ")")]), _vm._v(" " + _vm._s(_vm.set_str_attr.product.name) + "s")])]), _vm._v(" "), _vm._l((_vm.products), function(set_product, index) {
    return (set_product.product_is_addon == 0) ? _c('div', {
      staticClass: "col-md-2 col-xs-4",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('div', {
      staticClass: "card-cd-item",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.product = set_product;
          _vm.getSetProduct(_vm.product);
          _vm.setToView('viewItem');
        }
      }
    }, [_c('div', {
      staticClass: "c-col-img col-md-12 col-md-12 mp0",
      staticStyle: {
        "z-index": "5",
        "background": "#ffffff",
        "border-radius": "14px"
      }
    }, [(set_product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "border-radius": "14px"
      },
      attrs: {
        "src": set_product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "border-radius": "14px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card col-md-12 col-xs-12 mp0"
    }, [(_vm.site_view == 1) ? _c('div', {
      staticClass: "card-details prd-name-2-lines",
      staticStyle: {
        "z-index": "1",
        "background": "#ffffff",
        "padding": "5px",
        "padding-top": "0.5em"
      }
    }, [_c('p', {
      staticClass: "prd-name-2-lines",
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(set_product.product_name))])]) : _vm._e(), _vm._v(" "), (_vm.site_view == 2) ? _c('div', {
      staticClass: "card-details prd-name-2-lines",
      staticStyle: {
        "z-index": "1",
        "background": "#ffffff",
        "padding": "5px",
        "padding-top": "0.5em"
      }
    }, [_c('p', {
      staticClass: "prd-name-2-lines",
      staticStyle: {
        "font-size": "13px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(set_product.product_name))])]) : _vm._e()])])])]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "t-title"
  }, [_c('b', [_vm._v("Name: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "t-title"
  }, [_c('b', [_vm._v("Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "t-title"
  }, [_c('b', [_vm._v("Category: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-left-xx"
  }, [_c('h4', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Set Options for ordering\r\n                        "), _c('button', {
    staticClass: "btn sp-button-02-lt btn-a-set-xs fl-r-xs",
    staticStyle: {
      "margin-top": "-0.3em"
    }
  }, [_vm._v(" Set Options "), _c('i', {
    staticClass: "fas fa-angle-down"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-left"
  }, [_c('h3', [_vm._v("Types/Options/Sizes/Colors (optional)")]), _vm._v(" "), _c('p', [_vm._v("Different types or options of this Item that can be selected:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-right"
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt btn-a-set-xs"
  }, [_vm._v(" Set "), _c('i', {
    staticClass: "fas fa-angle-down"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block",
      "font-size": "14px",
      "padding": "0"
    }
  }, [_c('li', [_vm._v("Large - ₦‎5000")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("Small - ₦‎2500")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-left"
  }, [_c('h3', [_vm._v("Order Extras (optional)")]), _vm._v(" "), _c('p', [_vm._v("Extra items or options that can be selected when ordering")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-right"
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt btn-a-set-xs"
  }, [_vm._v(" Set "), _c('i', {
    staticClass: "fas fa-angle-down"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-left"
  }, [_c('h3', [_vm._v("Add/Remove Options (optional)")]), _vm._v(" "), _c('p', [_vm._v("List what can added or removed from order, eg. pepper, onions, vegetable ..."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("eg: Someone may not want pepper or salt added or may allergic to vegetable ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-right"
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt btn-a-set-xs"
  }, [_vm._v(" Set "), _c('i', {
    staticClass: "fas fa-angle-down"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Different options that can be selected for this order "), _c('br'), _vm._v(" "), _c('b', [_vm._v("eg. Chicken large portion - "), _c('span', [_vm._v("₦750")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-down",
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "24px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("Delete Picture ?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("New"), _c('br'), _vm._v("Photo")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-down",
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "24px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "t-title"
  }, [_c('b', [_vm._v("Name: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "t-title"
  }, [_c('b', [_vm._v("Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "t-title"
  }, [_c('b', [_vm._v("Category: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('b', [_vm._v("Description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-left"
  }, [_c('h3', [_vm._v("Types/Options/Sizes/Colors")]), _vm._v(" "), _c('p', [_vm._v("Different options that can be selected for this order . eg:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-down",
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "24px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Remove Option ?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-left"
  }, [_c('h3', [_vm._v("Order Extras")]), _vm._v(" "), _c('p', [_vm._v("What is in your order that can be removed, can be ordered without... eg. onions, vegetable ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-right"
  }, [_c('i', {
    staticClass: "fas fa-angle-down",
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "24px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Remove Option ?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "t-title"
  }, [_c('b', [_vm._v("Name: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('span', {
    staticClass: "t-title"
  }, [_c('b', [_vm._v("Price: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "t-title"
  }, [_c('b', [_vm._v("Category: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "width": "100%",
      "background": "#c20312",
      "border-color": "#c20312",
      "color": "#ffffff"
    }
  }, [_vm._v("\r\n              Saving "), _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin",
    staticStyle: {
      "color": "#ffffff"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fas fa-arrow-right"
  }), _vm._v(" Store Item")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "width": "100%",
      "background": "#c20312",
      "border-color": "#c20312",
      "color": "#ffffff"
    }
  }, [_vm._v("\r\n                    Saving "), _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin",
    staticStyle: {
      "color": "#ffffff"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0f54126"}!./src/pages/Components/ItemsManagement/template.html
// module id = 633
// module chunks = 0